import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }
  
  if (!user) {
    // Not logged in at all - redirect to login
    return <Navigate to="/login" replace />;
  }
  
  if (user.role !== 'admin') {
    // Logged in but not admin - redirect to home
    return <Navigate to="/" replace />;
  }
  
  return children;
}
